<template>
  <!-- Payout 收款方页面 -->
  <contact-payout v-if="isPayout || businessType === 'payout'"></contact-payout>
  <!-- 非 Payout 收款方页面 -->
  <contact-normal v-else></contact-normal>
</template>
<script>
import { mapGetters } from 'vuex';

import ContactNormal from '@/views/transfer/contact/edit/normal.vue';
import ContactPayout from '@/views/transfer/contact/edit/payout.vue';

export default {
  components: {
    ContactPayout,
    ContactNormal,
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    businessType() {
      return this.$route.query.businessType || '';
    },
  },
  data() {
    return {
      isPayout: false,
    };
  },
  created() {
    // 商户类型
    try {
      const userLogin = this.app.userLogin;
      if (userLogin && (userLogin.businessType === '0' || this.businessType === 'payout')) {
        this.isPayout = true;
      } else if (userLogin && userLogin.businessType === '2') {
        this.isPayout = false;
      }
    } catch (error) {
      //
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.contact-form {
  width: 450px;
  margin: 20px auto 0;

  ::v-deep .rhch-upload-container {
    width: 450px;
    min-width: auto;
    .el-upload-dragger, .rhch-file-list {
        width: 450px;
        min-width: auto;
    }

    .rhch-file-list .rhch-file-item .rhcn-filename {
      max-width: 240px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .btn-save-contact {
    font-size: 14px;
    font-weight: bold;
    color: $color-text-primary;
    line-height: 32px;
  }

  .bottom-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .btn-previous {
      cursor: pointer;
      color: $color-text-default-button;
      font-weight: 600;
    }
  }
}
</style>
